export enum SelectUserOption {
  Myself = 'myself',
  SomeoneElse = 'someone else',
}

export interface SelectUserProps {
  firstName?: string;
  setShowSelectUser(state: boolean): void;
}

export interface LabelProps {
  firstName?: string;
  option: SelectUserOption;
}
